import _ from "lodash";
import client from "lib/apolloClient/client";
import { getResourceListQueryV2 } from "./Queries";

export const getResourceBankDetailsFromCache = ({ input }) => {
  try {
    const queryData = client.readQuery({
      query: getResourceListQueryV2,
      variables: {
        input,
      },
    });

    return _.get(queryData, "platform", {});
  } catch (e) {
    return {};
  }
};
